export enum ValidationMessageKey {
    Digits = 'digits',
    Email = 'email',
    EmailAlreadyExist = 'emailAlreadyExist',
    Maxlength = 'maxlength',
    MinLength = 'minlength',
    NgbDate = 'ngbDate',
    PasswordsMismatch = 'passwordsMismatch',
    WeakPassword = 'weakPassword',
    Pattern = 'pattern',
    Required = 'required',
    WrongPasswordOrUsername = 'wrongPasswordOrUsername'
}
